/**
 * Configuration de la devise
 */
export const currencyConfig = {
  code: 'MAD',
  symbol: 'DH',
  position: 'after',
  decimalSeparator: ',',
  thousandSeparator: ' '
};

/**
 * Formate un montant selon la configuration de devise
 * @param {number} amount - Le montant à formater
 * @param {Object} config - Configuration de la devise (optionnel)
 * @returns {string} Le montant formaté
 */
export const formatCurrency = (amount, config = currencyConfig) => {
  if (amount === null || amount === undefined) return 'Non disponible';

  const {
    symbol,
    position,
    decimalSeparator,
    thousandSeparator
  } = config;

  const formattedAmount = Number(amount).toFixed(2)
    .replace('.', decimalSeparator)
    .replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

  return position === 'after'
    ? `${formattedAmount} ${symbol}`
    : `${symbol} ${formattedAmount}`;
};

/**
 * Convertit une chaîne de caractères en nombre
 * @param {string} value - La valeur à convertir
 * @param {Object} config - Configuration de la devise (optionnel)
 * @returns {number} Le nombre converti
 */
export const parseCurrency = (value, config = currencyConfig) => {
  if (!value) return 0;

  const {
    decimalSeparator,
    thousandSeparator
  } = config;

  return Number(
    value
      .replace(new RegExp(`\\${thousandSeparator}`, 'g'), '')
      .replace(decimalSeparator, '.')
  );
}; 